import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {SmsDTO} from '../models/sms/SmsDTO';

@Injectable({
  providedIn: 'root'
})
export class SmsService {
  private url = environment.baseUrl + '/sms';

  constructor(private httpClient: HttpClient) {
  }

  getListOfSMS(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<SmsDTO>> {
    return this.httpClient.post<PagedResponseDTO<SmsDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  sendSms(smsDTO: SmsDTO): Observable<SmsDTO> {
    return this.httpClient.post<SmsDTO>(this.url + '/send', smsDTO);
  }

}
